import baseApi from '../api/baseApi';

const dictionaryApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getMaterials: builder.query({
      query: () => ({
        url: '/dictionaries/materials/all',
        method: 'GET',
      }),
      keepUnusedDataFor: 3600,
    }),
    getGrilledMaterials: builder.query({
      query: () => ({
        url: '/dictionaries/grilled-materials/all',
        method: 'GET',
      }),
      keepUnusedDataFor: 3600,
    }),
  }),
});

export const {
  useGetMaterialsQuery: useGetFriedMaterials,
  useGetGrilledMaterialsQuery: useGetGrilledMaterials,
  useLazyGetMaterialsQuery: useLazyGetFriedMaterials,
  useLazyGetGrilledMaterialsQuery: useLazyGetGrilledMaterials,
} = dictionaryApi;

export default dictionaryApi;
